import './driverVideoSlider.css';
import Slider from "react-slick";
const DriverVideoSlider = () => {
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        centerPadding: '32px'
    };
    return(
        <div className={'driverVideoSlider'}>
            <Slider  {...settings}>
                <div className="slide icon width-block-100">
                    <div className="content"></div>
                </div>
                <div className="slide icon width-block-100">
                    <div className="content"></div>
                </div>
                <div className="slide icon width-block-100">
                    <div className="content"></div>
                </div>
                <div className="slide icon width-block-100">
                    <div className="content"></div>
                </div>
                <div className="slide icon width-block-100">
                    <div className="content"></div>
                </div>
                <div className="slide icon width-block-100">
                    <div className="content"></div>
                </div>
            </Slider>
        </div>
    )
}

export default DriverVideoSlider;
